/**
 * Extracts error message from different error types
 * Handles both string errors (from inline validators) and object errors (from Zod)
 */
export const getErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === "string") return error;
  if (error && typeof error === "object" && "message" in error) {
    return (error as { message: string }).message;
  }
  return undefined;
};
